import { render } from "./RoleMenuList.vue?vue&type=template&id=3844dd76"
import script from "./RoleMenuList.vue?vue&type=script&lang=js"
export * from "./RoleMenuList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__